// Common fields used by all lookup tables
export const lookupTableFields = ['label', 'shortCode', 'description', 'examples'];
const searchFields = ['label', 'shortCode'];

export const lookupTableClasses =  [
        {
          className: "EventType",
          classNameLabel: "Event Type",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "Reproduction",
          classNameLabel: "Reproduction",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "NativityType",
          classNameLabel: "Nativity Type",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "InvasiveStatus",
          classNameLabel: "Invasive Status",
          fields: lookupTableFields,
          searchFields: searchFields    
        },
        {
          className: "SecurityType",
          classNameLabel: "Security Type",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "TaxonomySystem",
          classNameLabel: "Taxonomy System",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "Substantiation",
          classNameLabel: "Substantiation",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "LocDeterminization",
          classNameLabel: "Location Determined Method",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "Substrate",
          classNameLabel: "Substrate",
          fields: ['label', 'description', 'examples'],
          searchFields: ['label']
        },
        {
          className: "ObservationQuality",
          classNameLabel: "Observation Quality",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "EvidenceFormat",
          classNameLabel: "Evidence Format",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "SourceOwned",
          classNameLabel: "Source Owned",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "Repository",
          classNameLabel: "Repository",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "LocationShape",
          classNameLabel: "Location Shape",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "Town",
          classNameLabel: "Town",
          fields: ['label', 'shortCode'],
          searchFields: searchFields
        },
        {
          className: "Keyword",
          classNameLabel: "Keyword",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
          className: "ProtectedStatus",
          classNameLabel: "Protected Status",
          fields: lookupTableFields,
          searchFields: searchFields
        },
        {
            className: "Subject",
            classNameLabel: "Subject",
            fields: ['label', 'shortCode'],
            searchFields: ['label', 'shortCode']
        },
        {
          className: "SRank",
          classNameLabel: "SRank",
          fields: ['label', 'shortCode'],
          searchFields: ['label', 'shortCode']
        },
        {
          className: "RIGCN",
          classNameLabel: "RIGCN",
          fields: ['label', 'shortCode'],
          searchFields: ['label', 'shortCode']
        }
];



export default {
    lookupTableClasses,
    getLookupTableClass: (className) => lookupTableClasses.find(c => c.className === className)
}